import cxeLayout from "./layout";
import popularData from "./popularData";
import cxeBundles from "./bundle";
import buyerIntent from "./buyerIntent";
import news from "./news";
export default {
  cxeLayout: cxeLayout,
  popularData: popularData,
  cxeBundles: cxeBundles,
  buyerIntent: buyerIntent,
  news: news
};